module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/nagoya_point1_4-48bc24e9e1f642b96ba65e8c6d8ae2d0.jpg";